<template>
    <div>
        <p>
            <strong>Zgodnie z art. 1341 i 1342 włoskiego Kodeksu cywilnego</strong>, Użytkownik oświadcza, że wyraźnie zapoznał się, zrozumiał i
            zaakceptował następujące postanowienia:
        </p>
        <p>Art. 1 Definicje, lit. l), „Fleequid”, podmiot prawny oraz właściwe przepisy podatkowe;</p>
        <p>Art. 2.3 Prowizje należne zarówno od Sprzedawcy, jak i od Nabywcy;</p>
        <p>Art. 2.4 Zasady aukcji oraz ustalanie ceny przybicia;</p>
        <p>Art. 2.5 Proces odsprzedaży;</p>
        <p>
            Art. 3 Zatwierdzenie ewentualnych ogólnych warunków proponowanych przez użytkowników, jednostronna zmiana OWU przez Fleequid oraz
            hierarchia dokumentów umownych;
        </p>
        <p>Art. 4.5 Ograniczenia korzystania z Marketplace;</p>
        <p>Art. 4.6 Środki podejmowane przez Fleequid w przypadku naruszenia zasad korzystania;</p>
        <p>Art. 4.7 Rozwiązanie;</p>
        <p>Art. 4.8 Kara umowna;</p>
        <p>Art. 4.10 Wyłączenie odpowiedzialności za funkcjonowanie Marketplace;</p>
        <p>Art. 4.11 Usunięcie profilu Użytkownika oraz wykonanie prawa odstąpienia;</p>
        <p>
            Art. 6 dotyczący: wyraźnej klauzuli rozwiązującej, wyłączności sprzedaży, warunków i czasu trwania tej wyłączności, możliwości kolejnego
            przybicia, ograniczeń sprzedaży, możliwości anulowania lub rozwiązania sprzedaży w przypadku opóźnienia lub braku płatności Nabywcy,
            zrzeczenia się przez Sprzedawcę roszczeń lub zarzutów, klauzuli zwolnienia z odpowiedzialności, dokumentacji technicznej, kar umownych
            obciążających Sprzedawcę;
        </p>
        <p>
            Art. 7 Zaproszenie do składania ofert (invitatio ad offerendum), czas trwania nieodwołalnej oferty zakupu, szczególne warunki aukcji, cena
            rezerwowa;
        </p>
        <p>Art. 8.4 Zasady dotyczące depozytu zabezpieczającego;</p>
        <p>Art. 9.3 Zapłata ceny pojazdu;</p>
        <p>
            Art. 9.4 Wcześniejsze fakturowanie na żądanie Fleequid, warunek zawieszający zapłatę uzależniony od pełnego otrzymania płatności od
            Nabywcy (pay-when-paid), obowiązek wystawienia noty kredytowej w przypadku braku płatności lub anulowania sprzedaży, prawo kompensaty,
            dzienne kary za opóźnienia lub zaniechania oraz zrzeczenie się przez Sprzedawcę roszczeń lub zarzutów wobec Fleequid;
        </p>
        <p>Art. 9.5 Kara umowna;</p>
        <p>Art. 9.7 i 9.8 Terminy zgłaszania wad i usterek;</p>
        <p>Art. 9.10 Wyraźna klauzula rozwiązująca i kara umowna;</p>
        <p>
            Art. 10 Warunki płatności, rozwiązanie, kary umowne, warunki regulujące odsprzedaż i zwolnienie z odpowiedzialności, przebieg, terminy
            weryfikacji wad przy odbiorze;
        </p>
        <p>
            Art. 11 Wyłączenie gwarancji i zwolnienie z odpowiedzialności Fleequid, przejście ryzyka, wyraźna klauzula rozwiązująca, kary umowne,
            prawo anulowania sprzedaży, wyłączenie wad ukrytych, ograniczenia odpowiedzialności oparte na przebiegu i wieku pojazdu;
        </p>
        <p>
            Art. 13 Reklamacje, propozycje ich rozpatrzenia, rozstrzygnięcie reklamacji przez Fleequid poprzez anulowanie sprzedaży, wady ukryte,
            zwolnienie z odpowiedzialności, klauzula „stan jak jest”, kary umowne;
        </p>
        <p>Art. 14 Klauzula powiązania;</p>
        <p>Art. 15 Prawo właściwe, język i sąd właściwy.</p>
    </div>
</template>
